export const SUP_ONLINE_TOOLS_GENERAL_LOADER = {
  desktop: `
<div class="cui-grid cui-container">

  <!-- Breadcrumbs skeleton -->
  <div class="cui-skeleton-paragraph -spacing--top-64 -spacing--bottom-40">
    <div class="cui-skeleton-paragraph__content" style="width: 170px">
      <div class="cui-skeleton__item cui-skeleton__description" style="height: 26.281px;"></div>
    </div>
  </div>

  <!-- Title Skeleton -->
  <div class="cui-skeleton-heading -size--large -resolution--desktop -spacing--bottom-40">
    <div class="cui-skeleton-heading__content">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      <div class="cui-skeleton__item cui-skeleton__description -spacing--top-8" style="height: 27.891px;"></div>
    </div>
  </div>

  <!-- Content Skeleton -->
  <div class="cui-row -spacing--bottom-120"> 
    <div class="cui-col-md-6 cui-col-sm-4">
      <div class="cui-skeleton-rectangle -is--block">
        <div class="cui-skeleton__item" style="width: 100%; height: 432px;"></div>
      </div>
    </div>
  </div>
</div>
`
};
